/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { DBSchema, OpenDBCallbacks } from "idb";
import { DairyFARMDB } from "../store";

export const WMPS_STORE = "wmps" as "wmps";

export interface Wmp {
  id: string;
  facility: string;
  facilityId: string;
  dateInitiated: string;
}

export interface WmpsStore extends DBSchema {
  [WMPS_STORE]: {
    key: string;
    value: Wmp;
  };
}

export const wmpStoreConfig: OpenDBCallbacks<DairyFARMDB> = {
  upgrade(db, oldVersion, newVersion, transaction) {
    if (!db.objectStoreNames.contains(WMPS_STORE)) {
      db.createObjectStore(WMPS_STORE, {
        keyPath: "id",
      });
    }
  },
};
